module.exports = __webpack_public_path__ + "static/img/the-box.69f407d1.png";